// extracted by mini-css-extract-plugin
export default {"header":"tB","discountBanner":"uB","logo":"vB","maincontainer":"wB","videocontainer":"xB","videowelcome":"yB","videowrapper":"zB","videosale":"AB","loadingcontainer":"BB","footer":"CB","footerbutton":"EB","video":"FB","logoname":"GB"};
    if(module.hot) {
      // 1713969933393
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  